<template>
  <v-skeleton-loader
    :loading="loading"
    type="heading, table-thead, table-row-divider@8"
  >
    <v-card>
      <v-card-title class="py-0">
        <h2 class="text-h2 mt-10 mb-7">
          {{ $t('rateConfigurationStrings.receiptTitle') }}
        </h2>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            lg="8"
            xl="6"
          >
            <v-table>
              <template #default>
                <thead>
                  <tr>
                    <th
                      class="text-left"
                    >
                      {{ $t('rateConfigurationStrings.receiptTypeTableActiveHeader') }}
                    </th>
                    <th class="text-left">
                      {{ $t('rateConfigurationStrings.receiptTypeTableTypeHeader') }}
                    </th>
                    <th
                      class="text-left"
                    >
                      {{ $t('rateConfigurationStrings.receiptTypeTableRequiresAttachmentHeader') }}
                    </th>
                    <th
                      class="text-left"
                    >
                      {{ $t('rateConfigurationStrings.receiptTypeTableAccountingHeader') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in filteredReceiptRateTypes"
                    :key="item.rateType"
                  >
                    <td>
                      <vee-field
                        v-slot="{ componentField }"
                        v-model="item.enabled"
                        rules
                        :vid="getReceiptEnabledValidationId(item.rateType)"
                      >
                        <v-checkbox
                          v-bind="componentField"
                          color="primary"
                          :aria-label="$t('commonStrings.tableAriaLabel',[$t('rateConfigurationStrings.receiptTypeTableActiveHeader'),
                                                                          $t(`enums.receiptTypes.${item.rateType}`)])"
                        />
                      </vee-field>
                    </td>
                    <td>{{ $t(`enums.receiptTypes.${item.rateType}`) }}</td>
                    <td>
                      <v-checkbox
                        v-model="item.requiresAttachment"
                        color="primary"
                        :aria-label="$t('commonStrings.tableAriaLabel',[$t('rateConfigurationStrings.receiptTypeTableRequiresAttachmentHeader'),
                                                                        $t(`enums.receiptTypes.${item.rateType}`)])"
                        :disabled="!item.enabled"
                      />
                    </td>
                    <td>
                      <vee-field
                        v-slot="{ componentField, errors }"
                        v-model="item.accountingId"
                        rules="finance_account"
                        :name="$t('rateConfigurationStrings.receiptTypeTableAccountingHeader')"
                        :vid="getReceiptAccountingIdValidationId(item.rateType)"
                      >
                        <v-text-field
                          v-bind="componentField"
                          variant="outlined"
                          density="compact"
                          :error-messages="errors"
                          :aria-label="$t('commonStrings.tableAriaLabel',[$t('rateConfigurationStrings.receiptTypeTableAccountingHeader'),
                                                                          $t(`enums.receiptTypes.${item.rateType}`)])"
                          :disabled="!item.enabled"
                        />
                      </vee-field>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import { Field as VeeField } from "vee-validate";
import InactiveReceiptTypes from "@/enums/InactiveReceiptTypes";

export default {
  name: "ReceiptSettings",
  components: {
    VeeField
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    receiptRates: {
      type: Object,
      required: true
    }
  },
  computed: {
    filteredReceiptRateTypes() {
      return this.receiptRates.receiptRateTypes.filter(x => Object.values(InactiveReceiptTypes).every(y => y !== x.rateType));
    }
  },
  methods: {
    getReceiptEnabledValidationId(rateType) {
      return `enabled_receiptType_${rateType}`;
    },
    getReceiptAccountingIdValidationId(rateType) {
      return `accountingId_receiptType_${rateType}`;
    }
  }
};
</script>
